import React, {ChangeEvent} from 'react';
import cn from 'classnames';

interface IMultipleCheckbox extends React.HTMLProps<HTMLInputElement> {
  title?: string;
  id?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  isRotate?: boolean;
  customClass?: string;
  titleClass?: string;
}

const CustomMultiCheckbox = ({
  title,
  id,
  onChange,
  isRotate,
  customClass,
  titleClass,
  ...props
}: IMultipleCheckbox) => {
  return (
    <label
      className={cn('flex items-center justify-start px-2', customClass)}
    >
      {isRotate ? (
        <>
          <input {...props} type="checkbox" onChange={onChange} />
          <span className={cn('text-sm mr-2', titleClass)}>{title}</span>
        </>
      ) : (
        <>
          <input {...props} type="checkbox" onChange={onChange} />
          <span className={cn('text-sm mr-2', titleClass)}>{title}</span>
        </>
      )}
    </label>
  );
};

export default CustomMultiCheckbox;
